import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import DOMPurify from 'dompurify'

import css from './sass/markdown.module.scss'
import themeCss from '../components/sass/theme.module.scss'

export default function RichText({ text, cssClass, noLineBreaks, linkObj }) {
  const safeText = text ?? ''
  const textRef = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const checkIfTruncated = () => {
      if (!textRef.current) return

      const currentText = textRef.current
      setIsTruncated(currentText.scrollHeight > currentText.clientHeight)
    }

    checkIfTruncated()
    window.addEventListener('resize', checkIfTruncated)

    return () => {
      window.removeEventListener('resize', checkIfTruncated)
    }
  }, [safeText, cssClass, noLineBreaks])

  const linkElement = (
    <Link
      className={`${css['link-toitem']} ${themeCss['bold-nodecoration']}`}
      to={{
        pathname: linkObj?.browse ? '/browse/item' : '/auction/item',
        search: `?auctionId=${linkObj?.auctionCode}&itemId=${linkObj?.itemCode}`,
      }}
      onClick={linkObj?.onClick}
    >
      More...
    </Link>
  )

  const fixedLinkElement = (
    <Link
      className={`${css['link-toitem']} ${themeCss['bold-nodecoration']}`}
      to={{
        pathname: linkObj?.browse ? '/browse/fixeditem' : '/auction/fixeditem',
        search: `?auctionId=${linkObj?.auctionCode}&fixedItemId=${linkObj?.itemCode}`,
      }}
      onClick={linkObj?.onClick}
    >
      More...
    </Link>
  )

  return (
    <>
    {/* to render trusted-looking rich text HTML as actual HTML in React */}
      <div
        ref={textRef}
        className={cssClass || 'none'}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(safeText),
        }}
      />
      {isTruncated && linkObj?.link === 'itemPage' ? linkElement : ''}
      {isTruncated && linkObj?.link === 'fixedItemPage' ? fixedLinkElement : ''}
    </>
  )
}
